import { inject, type InjectionKey } from "vue";
import type { RiskAssessmentConsultableType } from "@/vue/entities/risk-assessment";
import type { RiskAssessmentDraftState } from "./useRiskAssessmentDraft";

// 区分（夜間相談 / 日中助産師）の画面内で、相談ごとに入力途中の内容を保持する。
// 区分のルート親コンポーネントが provide するため、区分から出ると親ごと unmount され全件破棄される。
// localStorage 等には保存せず、モジュールスコープにも置かない（DR-002）。
export type RiskAssessmentDraftStore = {
  scopeLabel: string;
  take: (type: RiskAssessmentConsultableType, id: string) => RiskAssessmentDraftState | null;
  save: (type: RiskAssessmentConsultableType, id: string, state: RiskAssessmentDraftState | null) => void;
};

export const RISK_ASSESSMENT_DRAFT_STORE_KEY: InjectionKey<RiskAssessmentDraftStore> = Symbol("riskAssessmentDraftStore");

const keyOf = (type: RiskAssessmentConsultableType, id: string): string => `${type}:${id}`;

export const createRiskAssessmentDraftStore = (scopeLabel: string): RiskAssessmentDraftStore => {
  const states = new Map<string, RiskAssessmentDraftState>();

  const take = (type: RiskAssessmentConsultableType, id: string): RiskAssessmentDraftState | null => {
    const key = keyOf(type, id);
    const state = states.get(key) ?? null;
    states.delete(key);
    return state;
  };

  const save = (type: RiskAssessmentConsultableType, id: string, state: RiskAssessmentDraftState | null): void => {
    const key = keyOf(type, id);
    if (state) {
      states.set(key, state);
    } else {
      states.delete(key);
    }
  };

  return { scopeLabel, take, save };
};

export const injectRiskAssessmentDraftStore = (): RiskAssessmentDraftStore | null =>
  inject(RISK_ASSESSMENT_DRAFT_STORE_KEY, null);
